import { CloseButtonWrap } from './style'

const CloseButton = ({ onClick, className, ...restProps }) => {
  return (
    <CloseButtonWrap onClick={onClick} className={className} {...restProps}>
      <span></span>
    </CloseButtonWrap>
  )
}

export default CloseButton
